// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__I3qfi","head":"Table_head__2HYqX","col":"Table_col__3q-hN"};